import { number, shape } from 'prop-types';
import { useTheme } from 'styled-components';

import { toCurrency } from 'utils/number';

const YAxisTick = ({ x = 0, y = 0, payload }) => {
  const theme = useTheme();

  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={-2}
        dx={-10}
        fill={theme.new.colors.N600}
        fontSize={14}
        fontWeight={theme.fontWeights.normal}
        fontFamily={theme.new.fontFamily}
        textAnchor="end"
      >
        {toCurrency(payload?.value, {
          notation: 'compact',
          minimumFractionDigits: 0,
          maximumFractionDigits: 2
        })}
      </text>
    </g>
  );
};

YAxisTick.propTypes = {
  payload: shape({ value: number }),
  x: number,
  y: number
};

export default YAxisTick;
